import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { Faq, FaqSection } from '../../../../classes/http-responses';
import { AppSettings } from '../../../../app.settings';

@Component({
	selector: 'faq-category-item',
	template: require('./faq-category-item.component.html'),
})
export class FaqCategoryItemComponent {
	@Input() faq: Faq;
	@Input() faqSection: FaqSection;
	public sanitizedHtml: SafeHtml;
	public isRebrading = AppSettings.isRebrading;

	constructor(public sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		// this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.item.url);

		this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.faq.answer);
	}
	urlSafe: SafeResourceUrl;
}
